import { render, staticRenderFns } from "./TechnicalOverview.vue?vue&type=template&id=bd508fb6&scoped=true"
import script from "./TechnicalOverview.vue?vue&type=script&lang=js"
export * from "./TechnicalOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd508fb6",
  null
  
)

export default component.exports